import React from 'react';
import axios from 'axios';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { API_BASE_URL } from '../../utils';
import './vendor.scss';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import vendor from '../../Assets/vendor/vendor-iamge.png';
import vendorfail from '../../Assets/vendor/vendor-fail.png';

const VendorRegistrationForm = () => {
	const navigate = useNavigate();
	const initialValues = {
		firstName: '',
		lastName: '',
		email: '',
		phoneNumber: '',
		jobTitle: '',
		companyName: '',
		country: '',
		registeredAddress: '',
		shippingAddress1: '',
		shippingAddress2: '',
		yearOfEstablishment: '',
		GSTIN: '',
		CIN: '',
		PAN: '',
		bankDetails: {
			bankName: '',
			accountNumber: '',
			IFSC: '',
			branch: '',
		},
		turnover: '',
		manufacturingCountry: '',
		brand: '',
		companySize: '',
		numberOfProducts: '',
		mainProductDescription: '',
		avgLeadTime: '',
		minOrderQuantity: '',
		pricingManagement: '',
		supplierPortalExperience: false,
		productLabelsWithBarcode: false,
		businessProcessSoftware: '',
		acceptTermsAndConditions: false,
	};

	const validationSchema = Yup.object({
		firstName: Yup.string().required('Required'),
		lastName: Yup.string().required('Required'),
		email: Yup.string().email('Invalid email address').required('Required'),
		phoneNumber: Yup.string().required('Required'),
		jobTitle: Yup.string(),
		companyName: Yup.string().required('Required'),
		country: Yup.string().required('Required'),
		manufacturingCountry: Yup.string().required('Required'),
		yearOfEstablishment: Yup.number().required('Required'),
		registeredAddress: Yup.string().required('Required'),
		shippingAddress1: Yup.string().required('Required'),
		shippingAddress2: Yup.string(),
		GSTIN: Yup.string().required('Required'),
		CIN: Yup.string().required('Required'),
		PAN: Yup.string().required('Required'),
		bankDetails: Yup.object({
			bankName: Yup.string().required('Required'),
			accountNumber: Yup.string().required('Required'),
			IFSC: Yup.string().required('Required'),
			branch: Yup.string().required('Required'),
		}),
		turnover: Yup.string().required('Required'),
		brand: Yup.string().required('Required'),
		companySize: Yup.string().required('Required'),
		numberOfProducts: Yup.number().required('Required'),
		mainProductDescription: Yup.string().required('Required'),
		avgLeadTime: Yup.string().required('Required'),
		minOrderQuantity: Yup.string().required('Required'),
		pricingManagement: Yup.string().required('Required'),
		supplierPortalExperience: Yup.boolean(),
		productLabelsWithBarcode: Yup.boolean(),
		businessProcessSoftware: Yup.string(),
		acceptTermsAndConditions: Yup.boolean().oneOf(
			[true],
			'You must accept the terms and conditions'
		),
	});

	const handleSubmit = async (values, { setSubmitting }) => {
		const payload = {
			...values,
			bankDetails: {
				bankName: values.bankDetails.bankName,
				accountNumber: values.bankDetails.accountNumber,
				IFSC: values.bankDetails.IFSC,
				branch: values.bankDetails.branch,
			},
		};

		try {
			const response = await axios.post(`${API_BASE_URL}/vendor`, payload);
			if (response) {
				Swal.fire({
					icon: 'success',
					title: response?.data?.data?.message, // Dynamic title from response
					html: `
            <div style="background-color: #f8f9fa; padding: 20px; border-radius: 10px;">
                <img src=${vendor} alt="Success Image" style="width: 100px; margin-bottom: 15px;">
                <p style="font-size: 16px; color: #333;">Your vendor registration has been submitted successfully.</p>
                <p style="font-size: 14px; color: #666;"><strong>Note:</strong> Your submission is now under review. Our team will verify the documents and information you provided. Once approved, you will receive a confirmation email with login details for the vendor panel. We will notify you as soon as your account is ready. Stay tuned! 🚀</p>
            </div>
        `,
					background: '#ffffff',
					confirmButtonColor: '#007bff',
					confirmButtonText: 'OK',
				});
				navigate('/');
			} else {
				Swal.fire({
					icon: 'error',
					title: response.data.message,

					html: `
                        <div style="background-color: #f8d7da; padding: 20px; border-radius: 10px;">
                            <img src=${vendorfail} alt="Error Image" style="width: 100px; margin-bottom: 15px;">
                            <p style="font-size: 16px; color: #721c24;">There was an issue submitting your registration.</p>
                            <p style="font-size: 14px; color: #721c24;">Please try again later or contact support for assistance.</p>
                        </div>
                    `,
					background: '#ffffff',
					confirmButtonColor: '#dc3545',
					confirmButtonText: 'OK',
				});
			}

			console.log(response.data);
		} catch (error) {
			console.error('Error submitting form:', error);
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div className="container  ">
			<h1>Vendor Registration</h1>
			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={handleSubmit}
			>
				{({ isSubmitting }) => (
					<Form>
						{/* Basic Information */}
						<div className="section">
							<h6>1. Basic Information</h6>
							<Row>
								<Col>
									<div className="form-group">
										<label>First Name:</label>
										<Field
											type="text"
											name="firstName"
											placeholder="Enter your Name"
											className="input-field"
										/>
										<ErrorMessage
											name="firstName"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Last Name:</label>
										<Field
											type="text"
											name="lastName"
											placeholder="Enter your Name"
											className="input-field"
										/>
										<ErrorMessage
											name="lastName"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Email ID:</label>
										<Field
											type="email"
											name="email"
											placeholder="Enter your Email ID"
											className="input-field"
										/>
										<ErrorMessage
											name="email"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Phone Number:</label>
										<Field
											type="tel"
											name="phoneNumber"
											placeholder="Enter your Phone Number"
											className="input-field"
										/>
										<ErrorMessage
											name="phoneNumber"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Job Title:</label>
										<Field
											type="text"
											name="jobTitle"
											placeholder="Enter your Job Title"
											className="input-field"
										/>
									</div>
								</Col>
							</Row>
						</div>

						{/* Company Information */}
						<div className="section">
							<h6>2. Company Information</h6>
							<Row>
								<Col>
									<div className="form-group">
										<label>Legal Company Name:</label>
										<Field
											type="text"
											name="companyName"
											placeholder="Enter your Company Name"
											className="input-field"
										/>
										<ErrorMessage
											name="companyName"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Country:</label>
										<Field
											type="text"
											name="country"
											placeholder="Enter your Country"
											className="input-field"
										/>
										<ErrorMessage
											name="country"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Country Name of the Mfg./ Production:</label>
										<Field
											type="text"
											name="manufacturingCountry"
											placeholder="Enter your Country"
											className="input-field"
										/>
										<ErrorMessage
											name="manufacturingCountry"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Year of Establishment:</label>
										<Field
											type="number"
											name="yearOfEstablishment"
											placeholder="Enter the Year of establishment"
											className="input-field"
										/>
										<ErrorMessage
											name="yearOfEstablishment"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="form-group">
										<label>Registered Address:</label>
										<Field
											as="textarea"
											name="registeredAddress"
											placeholder="Enter your company registered address"
											className="input-field"
										/>
										<ErrorMessage
											name="registeredAddress"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Shipping Address 1:</label>
										<Field
											as="textarea"
											name="shippingAddress1"
											placeholder="Enter your Shipping Address"
											className="input-field"
										/>
										<ErrorMessage
											name="shippingAddress1"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Shipping Address 2:</label>
										<Field
											as="textarea"
											name="shippingAddress2"
											placeholder="Enter your Shipping Address"
											className="input-field"
										/>
									</div>
								</Col>
							</Row>
						</div>

						{/* Regulatory and Tax Information */}
						<div className="section">
							<h6>3. Regulatory and Tax Information</h6>
							<Row>
								<Col>
									<div className="form-group">
										<label>GSTIN:</label>
										<Field
											type="text"
											name="GSTIN"
											placeholder="GSTIN identification number"
											className="input-field"
										/>
										<ErrorMessage
											name="GSTIN"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>CIN:</label>
										<Field
											type="text"
											name="CIN"
											placeholder="Corporate Identification Number"
											className="input-field"
										/>
										<ErrorMessage
											name="CIN"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>PAN:</label>
										<Field
											type="text"
											name="PAN"
											placeholder="Permanent Account Number"
											className="input-field"
										/>
										<ErrorMessage
											name="PAN"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
							</Row>
						</div>

						{/* Banking Information */}
						<div className="section">
							<h6>4. Banking Information</h6>
							<Row>
								<Col>
									<div className="form-group">
										<label>Bank Name:</label>
										<Field
											type="text"
											name="bankDetails.bankName"
											placeholder="Enter your Bank Name"
											className="input-field"
										/>
										<ErrorMessage
											name="bankDetails.bankName"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Account Number:</label>
										<Field
											type="text"
											name="bankDetails.accountNumber"
											placeholder="Enter your Account Number"
											className="input-field"
										/>
										<ErrorMessage
											name="bankDetails.accountNumber"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Branch:</label>
										<Field
											type="text"
											name="bankDetails.branch"
											placeholder="Enter your bank branch"
											className="input-field"
										/>
										<ErrorMessage
											name="bankDetails.branch"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>IFSC Code:</label>
										<Field
											type="text"
											name="bankDetails.IFSC"
											placeholder="Enter your bank IFSC"
											className="input-field"
										/>
										<ErrorMessage
											name="bankDetails.IFSC"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Turn Over:</label>
										<Field
											type="text"
											name="turnover"
											placeholder="Approximate annual revenue"
											className="input-field"
										/>
										<ErrorMessage
											name="turnover"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
							</Row>
						</div>

						{/* Business and Production Details */}
						<div className="section">
							<h6>5. Business and Production Details</h6>
							<Row>
								<Col>
									<div className="form-group">
										<label>Brand:</label> <br />
										<span>
											Primary brand name under which products are sold
										</span>
										<Field
											type="text"
											name="brand"
											placeholder="Enter your brand name"
											className="input-field"
										/>
										<ErrorMessage
											name="brand"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Company Size:</label> <br />
										<span>Small, Medium, Large; or Number of employees</span>
										<Field
											type="text"
											name="companySize"
											placeholder="Enter your company Size"
											className="input-field"
										/>
										<ErrorMessage
											name="companySize"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>No. of Products:</label> <br />
										<span>Approximate number of unique products offered</span>
										<Field
											type="number"
											name="numberOfProducts"
											placeholder="Number of products"
											className="input-field"
										/>
										<ErrorMessage
											name="numberOfProducts"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Avg Lead Time:</label> <br />
										<span>Typical lead time for product delivery</span>
										<Field
											type="text"
											name="avgLeadTime"
											placeholder="Enter your Avg. time"
											className="input-field"
										/>
										<ErrorMessage
											name="avgLeadTime"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								{/* <Col>
                                    <div className="form-group">
                                        <label>Min Order Quantity Required:</label> <br />
                                        <span>Minimum order quantity for placing an order</span>
                                        <Field type="text" name="minOrderQuantity" placeholder='Enter your min order' className='input-field' />
                                        <ErrorMessage name="minOrderQuantity" component="div" className="error-message" />
                                    </div>
                                </Col> */}
							</Row>
							<Row>
								<Col>
									<div className="form-group">
										<label>Min Order Quantity Required:</label> <br />
										<span>Minimum order quantity for placing an order</span>
										<Field
											type="text"
											name="minOrderQuantity"
											placeholder="Enter your min order"
											className="input-field"
										/>
										<ErrorMessage
											name="minOrderQuantity"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col md={4}>
									<div className="form-group">
										<label>Main Product Description:</label>
										<Field
											as="textarea"
											name="mainProductDescription"
											placeholder="Brief description of key products"
											className="input-field"
										/>
										<ErrorMessage
											name="mainProductDescription"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
								<Col md={4}>
									<div className="form-group">
										<label>Pricing Management:</label>
										<Field
											as="textarea"
											name="pricingManagement"
											placeholder="Any specific pricing terms or considerations"
											className="input-field"
										/>
										<ErrorMessage
											name="pricingManagement"
											component="div"
											className="error-message"
										/>
									</div>
								</Col>
							</Row>
						</div>

						{/* Operational and Experience Details */}
						<div className="section">
							<h6>6. Operational and Experience Details</h6>
							<Row>
								<Col>
									<div className="form-group">
										<label>Supplier Portal Experience:</label> <br />
										<span>
											Experience level of prior experience with supplier
											portals
										</span>
										<div className="d-flex">
											<div>
												<label>
													<Field
														type="radio"
														name="supplierPortalExperience"
														value="true"
														className="m-2"
													/>
													Yes
												</label>
											</div>
											<div>
												<label>
													<Field
														type="radio"
														name="supplierPortalExperience"
														value="false"
														className="m-2"
													/>
													No
												</label>
											</div>
										</div>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Product Labels With Barcode:</label>
										<div className="d-flex ">
											<div>
												<label>
													<Field
														type="radio"
														name="productLabelsWithBarcode"
														value="true"
														className="m-2"
													/>
													Yes
												</label>
											</div>
											<div>
												<label>
													<Field
														type="radio"
														name="productLabelsWithBarcode"
														value="false"
														className="m-2"
													/>
													No
												</label>
											</div>
										</div>
									</div>
								</Col>
								<Col>
									<div className="form-group">
										<label>Business Process Software:</label>
										<br />
										<span>Any ERP, CRM, or software used in operations</span>
										<Field
											as="textarea"
											name="businessProcessSoftware"
											placeholder="Any ERP, CRM, or software used in operations"
											className="input-field"
										/>
									</div>
								</Col>
							</Row>
						</div>

						{/* Terms and Conditions */}
						<div className="section">
							<h5>Vendor Terms And Conditions</h5>
							<div className="form-group">
								<label>
									<Field type="checkbox" name="acceptTermsAndConditions" />
									Supplier Agree Terms And Conditions
								</label>
								<ErrorMessage
									name="acceptTermsAndConditions"
									component="div"
									className="error-message"
								/>
							</div>
						</div>

						<button type="submit" disabled={isSubmitting} className="submit-button">
							Submit
						</button>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default VendorRegistrationForm;
